import React from 'react';
import { Popover, PositionTransform } from 'react-tiny-popover';
import styled from '@benzinga/themetron';

interface Props {
  align?: 'start' | 'center' | 'end';
  content: React.ReactElement;
  positions?: ('right' | 'top' | 'bottom' | 'left')[];
  refHeight?: number | undefined;
  visible: boolean;
  transform?: PositionTransform;
  transformMode?: 'absolute' | 'relative';
}

export const TickerPopover: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <Popover
      align={props.align ?? 'start'}
      containerStyle={{ zIndex: '4000' }}
      content={props.content ?? undefined}
      isOpen={props.visible}
      positions={props.positions ?? ['right']}
      transform={props.transform}
      transformMode={props.transformMode}
    >
      <InnerContainer>{props.children}</InnerContainer>
    </Popover>
  );
};

const InnerContainer = styled.span`
  display: inherit;
  width: 100%;
`;
